'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to print progress bar
 */
    .directive('capProgressBar', function () {
        var Step = function (id, text, total, current) {
            this.id = id;
            this.text = text;

            this.left = function () {
                return (id == 1);
            };
            this.center = function () {
                return (id > 1 && id < total);
            };
            this.right = function () {
                return (id == total);
            };
            this.highlight = function () {
                return (id <= current);
            };
            this.last = function () {
                return (id == current);
            }
        };

        return {
            restrict: 'A',
            controller: ['$scope', 'progressBar', function ($scope, progressBar) {
                $scope.progressBar = progressBar;
                $scope.steps = undefined;
            }],
            link: function ($scope, element, attr) {
                $scope.$watch('progressBar.config', function() {
                    if ($scope.progressBar && $scope.progressBar.config && $scope.progressBar.config.progressBarEnabled === false)
                        element.hide();
                    else {
                        var labels = $scope.progressBar.getSteps();
                        var current = $scope.progressBar.getStep();

                        if (labels && current) {
                            $scope.steps = [];
                            for (var i = 0; i < labels.length; i++)
                                $scope.steps.push(new Step(i + 1, labels[i], labels.length, current));
                        }
                    }
                });
            },
            templateUrl: "templates/progressbar.html"
        };
    });